import {
    ALOG_GET_ALOG_LIST_BEGIN,
    ALOG_GET_ALOG_LIST_SUCCESS,
    ALOG_GET_ALOG_LIST_FAILURE,
    ALOG_GET_ALOG_LIST_DISMISS_ERROR,
  } from './constants';
  
  import request from '../../../utils/request'
  // Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
  // If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
  export function getAlogList(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: ALOG_GET_ALOG_LIST_BEGIN,
      });
     params.size = 10;

     const promise = new Promise((resolve, reject) => {
          request({
            method:'post',
            url:'/api/b/alog/list',
            data:params,
          }).then( data => {
              dispatch({
                  type: ALOG_GET_ALOG_LIST_SUCCESS,
                  data: Object.assign({},data,{page:params.page}),
              });
              resolve(data);
          }).catch (error => {
              dispatch({
                type: ALOG_GET_ALOG_LIST_FAILURE,
                data: { error: error },
              });
              reject(error);
          })
      });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissGetAlogListError() {
    return {
      type: ALOG_GET_ALOG_LIST_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case ALOG_GET_ALOG_LIST_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          getAlogListPending: true,
          getAlogListError: null,
        };
  
      case ALOG_GET_ALOG_LIST_SUCCESS:
        // The request is success
  
        const byId = {};
        const items = [];
        action.data.list.forEach(item => {
          items.push(item.id);
          byId[item.id] = item;
        });
        return {
          ...state,
          alogById:byId,
          alogList:items,
          alogPage: action.data.page,
          alogSize: action.data.size,
          alogTotal: action.data.count,
          getAlogListPending: false,
          getAlogListError: null,
        };
  
      case ALOG_GET_ALOG_LIST_FAILURE:
        // The request is failed
        return {
          ...state,
          getAlogListPending: false,
          getAlogListError: action.data.error,
        };
  
      case ALOG_GET_ALOG_LIST_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          getAlogListError: null,
        };
  
      default:
        return state;
    }
  }


// WEBPACK FOOTER //
// ./src/features/alog/redux/getAlogList.js